<script setup lang="ts">

</script>

<template>
  <footer class="d-flex justify-content-between footer">
    <div class="copyright">
      © <a href="https://hydralien.net">Borys Turchyk</a>, 2025
    </div>
    <div class="contacts">
      <span>Contact:</span>
      <!--        <a href="https://facebook.com/pidgingapp/">-->
      <!--          <font-awesome-icon :icon="['fab', 'facebook-square']"/>-->
      <!--        </a>-->
      <a href="mailto:hydra.public@gmail.com">
        <font-awesome-icon icon="envelope-square"/>
      </a>
    </div>
  </footer>
</template>

<style scoped>

</style>